// Import from canonical source to avoid duplication
import { isServerNoticesRoom } from './serverNoticesUtils';

// Re-export for backwards compatibility
export { isServerNoticesRoom };

/**
 * Check if the current user has permission to send messages in a room
 * Based on Matrix power levels (m.room.power_levels state event)
 * @param {Object} room - Matrix Room object
 * @param {Object} client - Matrix client instance
 * @returns {boolean} - true if user can send messages, false otherwise
 */
export const canSendMessages = (room, client) => {
  if (!room || !client) return false;
  
  const member = room.getMember(client.getUserId());
  if (!member) return false;
  
  const powerLevels = room.currentState.getStateEvents('m.room.power_levels', '');
  if (!powerLevels) return true; // No power levels = default allowed
  
  const content = powerLevels.getContent();
  const eventsDefault = content.events_default ?? 0;
  const userPowerLevel = member.powerLevel;
  
  return userPowerLevel >= eventsDefault;
};

/**
 * Get the translation key for why messages cannot be sent
 * @param {Object} room - Matrix Room object
 * @param {Object} client - Matrix client instance
 * @returns {string|null} - Translation key or null if no restriction
 */
export const getMessageRestrictionReason = (room, client) => {
  if (isServerNoticesRoom(room, client)) {
    return 'Messages.serverNoticesRestriction';
  }
  if (!canSendMessages(room, client)) {
    return 'Messages.noSendPermission';
  }
  return null;
};